import React from 'react'

export default function FieldNotImplemented(props) {
  return (
    <div className="badge bg-warning badge-lg d-block">{props.field.type}</div>
  )
}
